import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import GlowCard from './GlowCard';

// Soft icon-chip tint per tone (light surfaces) — the card itself stays white,
// matching the pilot dashboard's KPI look.
const CHIP = {
  blue: 'bg-blue-50 text-blue-600',
  emerald: 'bg-emerald-50 text-emerald-600',
  violet: 'bg-violet-50 text-violet-600',
  amber: 'bg-amber-50 text-amber-600',
  rose: 'bg-rose-50 text-rose-600',
  sky: 'bg-sky-50 text-sky-600',
  indigo: 'bg-indigo-50 text-indigo-600',
  slate: 'bg-slate-100 text-slate-600',
};

export const KpiCard = ({
  label,
  value,
  unit,
  tone = 'blue',
  icon: Icon,
  live = false,
  caption,
  onClick,
  testId,
  className = '',
}) => (
  <div className="h-full animate-fade-up">
    <GlowCard onClick={onClick} className={`p-5 flex flex-col justify-between min-h-[132px] ${className}`}>
      <div className="flex items-center justify-between">
        {Icon && (
          <div className={`w-9 h-9 rounded-xl flex items-center justify-center ${CHIP[tone] || CHIP.blue}`}>
            <Icon size={18} strokeWidth={1.9} />
          </div>
        )}
        {live && (
          <span className="bg-emerald-50 text-emerald-600 border border-emerald-200 text-[11px] font-medium px-2 py-0.5 rounded-full flex items-center gap-1">
            <ArrowUpRight size={12} strokeWidth={2.4} /> Live
          </span>
        )}
      </div>

      <div className="mt-3.5 flex items-baseline gap-1.5">
        <div className="text-2xl font-bold tracking-tight text-slate-900 font-display tabular-nums" data-testid={testId}>
          {value}
        </div>
        {unit && <div className="text-sm font-medium text-slate-400">{unit}</div>}
      </div>

      <div className="mt-auto pt-3">
        <div className="text-xs font-semibold text-slate-600">{label}</div>
        {caption && <div className="text-xs text-slate-400 mt-0.5">{caption}</div>}
      </div>
    </GlowCard>
  </div>
);

export default KpiCard;
